export default __webpack_public_path__ + "static/media/iconBg.7693a151.svg";